import { KEYBOARD_KEYS } from "@netapp/bxp-design-system-react";
import _ from "lodash";
import { useCallback } from "react";

export const useHomeNavigation = (index, onKeyDown = _.noop, onActivate = _.noop) => {
    return useCallback((e) => {
        const { key } = e;
        
        switch (key) {
            case KEYBOARD_KEYS.ARROW_DOWN:
                e.preventDefault();
                onKeyDown(e, index);
                break;
            case KEYBOARD_KEYS.ARROW_UP:
                e.preventDefault();
                onKeyDown(e, index);
                break;
            case KEYBOARD_KEYS.ENTER:
                onActivate();
                break;
            default:
                break;
        }
    }, [index, onKeyDown, onActivate]);
};
